// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3GFyF","footer":"Form_footer__1j90E"};